import { useMemo } from 'react';
import { useMyTeams } from './use-my-teams';
import { type FilterOption } from '../components/filters';

/**
 * Surfaces the current user's teams as "My team" entity-owner options and
 * exposes every catalog group (`groupOptions`), the owner lookup (`ownerByRef`)
 * and their display labels (`labelByRef`) so callers can offer area/parent
 * groups and expand them to descendants, mirroring the insights page. No
 * default selection is applied; the entity-owner filter is populated only from
 * the URL (e.g. when the page is opened from an insights or track link).
 */
export const useTeamOwnerFilter = () => {
  const {
    ownerByRef,
    labelByRef,
    groupOptions,
    teamRefs,
    primaryOwnedGroupRef,
  } = useMyTeams();

  const teamOptions = useMemo<FilterOption[]>(() => {
    const myTeamRefs = new Set(teamRefs);
    return groupOptions.filter(option => myTeamRefs.has(option.value));
  }, [teamRefs, groupOptions]);

  return {
    teamOptions,
    groupOptions,
    ownerByRef,
    labelByRef,
    primaryOwnedGroupRef,
  };
};
